import React, { useEffect } from "react";
import "./WashFold.css";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import SuitableforCleaen from "../ExpertServices/Suitablefor/Suitablefor"; 
import CleanServicesLaundry from "../CleanServicesLaundry/CleanServicesLaundry"

import Newwashfold from "./NewWashfold/Newwashfold";
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceAccordion from "../ServiceAccordion/ServiceAccordion";
export default function WashFold() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div>
      <section className="mawashFold mt-5">
         <Newwashfold  />
     
      </section>

    

     <div data-aos="fade-up">
         <SuitableforCleaen/>
      </div>
      <div data-aos="fade-up">
                  <ServiceAccordion></ServiceAccordion>
      </div>
      {/* <div data-aos="fade-up">
        <SuitableFor />
      </div> */}
      <div className="" data-aos="zoom-in-right">
      <CleanServicesLaundry />
  </div>

      <div>
      </div>
    </div>

  );
}
